export function RouteLoadingFallback() {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
      <div className="text-gray-400 text-sm">Loading...</div>
    </div>
  );
}
